module.exports = "/fonts/dripicons-v2.woff?11fc83ae11617015f2fcde2065fb34d3";